<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'ESTADOS.LBL_ESTADOS' | translate}}</h1>
  </div>
</div>
<p-tabView>
  <p-tabPanel header="{{ 'ESTADOS.LBL_LISTADOESTADOS' | translate}}">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
                label="{{ 'BTN_AGREGAR' | translate}}"></button>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda" (change)="setBusqueda()">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dt styleClass="table-premium"
                 [value]="estados" selectionMode="single" dataKey="idEstado"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigo}}</td>
              <td>{{row.nombre}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorEstadoInicial" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorEstadoFinal" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="btn-action-premium" icon="fa fa-eye" data-toggle="tooltip"
                          title="{{'BTN_VISUALIZAR' | translate}}"
                          pButton (click)="ver(row)"></button>
                  <button type="button" class="btn-action-premium" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                          (click)="editar(row)"></button>
                  <button type="button" class="btn-action-premium" icon="fa fa-users" data-toggle="tooltip"
                          title="{{'ESTADOS.BTN_ROLES' | translate}}" pButton *ngIf="menu.editar"
                          (click)="editarRoles(row)"></button>
                  <button type="button" class="btn-action-premium" icon="fa fa-bullseye" data-toggle="tooltip"
                          title="{{'ESTADOS.BTN_BOTONES' | translate}}" pButton *ngIf="menu.editar"
                          (click)="editarBotones(row)"></button>
                  <button type="button" class="btn-action-premium" icon="fa fa-magic" data-toggle="tooltip"
                          title="{{'ESTADOS.BTN_GESTIONARCAUSAL' | translate}}" pButton *ngIf="menu.editar"
                          (click)="gestionarCausal(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel header="{{ 'ESTADOS.LBL_REGLAS' | translate}}">

    <!-- Barra superior: Título, botón Agregar, Buscador y Filtro Multiselect -->
    <div class="grid align-items-center mb-3">
      <div class="col-12">
        <h3 style="font-weight: 600; color: #2d3748; margin: 0 0 12px 0;">
          {{ 'ESTADOS.LBL_REGLAS_INACTIVIDAD' | translate }}
        </h3>
      </div>
      <div class="col-1">
        <button type="button" pButton icon="fa fa-plus" id="btnAgregarRegla"
                class="btn-primary-full w-full"
                label="{{ 'BTN_AGREGAR' | translate }}"
                [disabled]="mostrarFormRegla"
                (click)="abrirFormRegla()"
                *ngIf="menu.agregar || menu.editar">
        </button>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               [(ngModel)]="busquedaReglas"
               (input)="filtrarReglas()">
      </div>
      <div class="col-12 md:col-6 lg:col-6 flex align-items-center justify-content-end gap-2 col-offset-2">
        <span style="font-size: 0.9rem; font-weight: 600; color: #495057; text-transform: uppercase;">
          {{ 'BTN_FILTRAR' | translate }}:
        </span>
        <span style="font-size: 0.85rem; color: #6c757d;">
          {{ 'ESTADOS.LBL_TIPOPRODUCTO' | translate }}
        </span>
        <p-multiSelect [options]="lisTiposProducto"
                       placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                       [(ngModel)]="tiposProductoFiltrados"
                       (onChange)="filtrarReglas()"
                       [maxSelectedLabels]="1"
                       selectedItemsLabel="{0} selected"
                       appendTo="body"
                       styleClass="w-15rem">
        </p-multiSelect>
        <button type="button" pButton class="btn-primary-outline" icon="fa fa-eraser"
                [disabled]="tiposProductoFiltrados.length === 0 && !busquedaReglas"
                (click)="limpiarFiltrosReglas()"
                label="{{ 'BTN_LIMPIAR' | translate }}">
        </button>
      </div>
    </div>

    <!-- Formulario deslizante (igual animación que GCC) -->
    <div class="form-transition-container" [class.visible]="mostrarFormRegla">
      <div class="p-4 mb-4 ml-2 mr-2" style="background-color: #f4f9f5; border-radius: 8px;">

        <h5 style="color: #155724; font-weight: 700; margin: 0 0 16px 0; text-transform: uppercase; font-size: 0.85rem; letter-spacing: 0.5px;">
          {{ (editandoRegla ? 'ESTADOS.LBL_EDITAR_REGLA' : 'ESTADOS.LBL_AGREGAR_REGLA') | translate }}
        </h5>

        <form [formGroup]="formularioRegla" novalidate>

          <!-- Fila 1: Tipo producto + Plataforma Digital + Banca Relacional -->
          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_TIPOPRODUCTO' | translate }}</label>
                <p-dropdown id="idTipoProductoBancario" name="idTipoProductoBancario"
                            [options]="lisTiposProducto"
                            (onChange)="actualizarListaEstadoOrigen(); fRegla.idEstadoOrigen.setValue(null)"
                            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                            optionLabel="label" optionValue="value"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            filter="true" class="dropdown-fondo-blanco"
                            formControlName="idTipoProductoBancario">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submittedRegla && fRegla.idTipoProductoBancario.invalid">
                  <i class="fa fa-close"></i> {{ 'ESTADOS.LBL_TIPOPRODUCTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
              <p-checkbox id="chkPlataforma" formControlName="indicadorPlataformaDigital" binary="true"
                          label="{{ 'ESTADOS.LBL_PLATAFORMADIGITAL' | translate }}">
              </p-checkbox>
            </div>
            <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
              <p-checkbox id="chkBanca" formControlName="indicadorBancaRelacional" binary="true"
                          label="{{ 'ESTADOS.LBL_BANCARELACIONAL' | translate }}">
              </p-checkbox>
            </div>
          </div>

          <!-- Fila 2: Estado origen + Días + Estado destino + Causal -->
          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_ESTADOORIGEN' | translate }}</label>
                <p-dropdown id="idEstadoOrigen" name="idEstadoOrigen"
                            [options]="lisEstadosOrigen"
                            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                            optionLabel="label" optionValue="value"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            filter="true" class="dropdown-fondo-blanco"
                            formControlName="idEstadoOrigen">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submittedRegla && fRegla.idEstadoOrigen.invalid">
                  <i class="fa fa-close"></i> {{ 'ESTADOS.LBL_ESTADOORIGEN' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_TIEMPOINACTIVIDAD' | translate }}</label>
                <input id="idDias" type="tel" pInputText min="1" numero-entero-reactive
                       placeholder="{{ 'LBL_INGRESAR' | translate }}" [maximo]="999" [maxLength]="3"
                       formControlName="dias" class="input-fondo-blanco">
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submittedRegla && fRegla.dias.invalid">
                  <i class="fa fa-close"></i> {{ 'ESTADOS.LBL_TIEMPOINACTIVIDAD' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_ESTADODESTINO' | translate }}</label>
                <p-dropdown id="idEstadoDestino" name="idEstadoDestino"
                            [options]="lisEstadosHabilitados"
                            (onChange)="validarCausal()"
                            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                            optionLabel="label" optionValue="value"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            filter="true" class="dropdown-fondo-blanco"
                            formControlName="idEstadoDestino">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submittedRegla && fRegla.idEstadoDestino.invalid">
                  <i class="fa fa-close"></i> {{ 'ESTADOS.LBL_ESTADODESTINO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'ESTADOS.LBL_CAUSAL' | translate }}</label>
                <p-dropdown id="idCausalSolicitud" name="idCausalSolicitud"
                            [options]="lisCausales"
                            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                            optionLabel="label" optionValue="value"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            filter="true" class="dropdown-fondo-blanco"
                            formControlName="idCausalSolicitud">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submittedRegla && fRegla.idCausalSolicitud.invalid">
                  <i class="fa fa-close"></i> {{ 'ESTADOS.LBL_CAUSAL' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Botones del formulario -->
          <div class="grid form-footer-buttons mt-3" *ngIf="!guardandoRegla">
            <div class="form-group col-12 flex justify-content-center gap-3">
              <button type="button" pButton class="btn-primary-outline" icon="fa fa-times"
                      id="btnCancelarRegla"
                      label="{{ 'BTN_CANCELAR' | translate }}"
                      (click)="cancelarFormRegla()">
              </button>
              <button type="button" pButton class="btn-primary-full" icon="fa fa-floppy-o"
                      id="btnGuardarRegla"
                      label="{{ 'BTN_GUARDAR' | translate }}"
                      (click)="guardarRegla()">
              </button>
            </div>
          </div>
          <div class="grid" *ngIf="guardandoRegla">
            <div class="col-12 text-center">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{ 'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>

        </form>
      </div>
    </div>

    <!-- Tabla de reglas -->
    <div class="grid mt-2">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnasReglas" styleClass="table-premium" #dt2
                 [value]="reglasFiltradas" [paginator]="true" [rows]="10" paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                  [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{ col.header }}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.tipoProducto }}</td>
              <td>{{ row.estadoOrigen }}</td>
              <td class="text-center">{{ row.dias }}</td>
              <td>{{ row.estadoDestino }}</td>
              <td>{{ row.causalSolicitud }}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorPlataformaDigital" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorBancaRelacional" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="btn-action-premium" icon="fa fa-pencil"
                          data-toggle="tooltip" title="{{ 'BTN_EDITAR' | translate }}"
                          pButton (click)="editarRegla(row)"
                          *ngIf="menu.agregar || menu.editar">
                  </button>
                  <button type="button" class="btn-action-premium" icon="fa fa-trash"
                          data-toggle="tooltip" title="{{ 'BTN_ELIMINAR' | translate }}"
                          pButton (click)="eliminarRegla(row)"
                          *ngIf="menu.agregar || menu.editar">
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </p-tabPanel>
</p-tabView>

<!-- Confirm Dialog para las reglas (cancelar cambios y eliminar) -->
<p-confirmDialog key="confirmReglas" #cdReglas>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close"
            label="{{ 'LBL_NO' | translate }}"
            (click)="cdReglas.reject()">
    </button>
    <button type="button" pButton icon="fa fa-check"
            label="{{ 'LBL_SI' | translate }}"
            (click)="cdReglas.accept()">
    </button>
  </ng-template>
</p-confirmDialog>
